
import * as Yup from 'yup';

export const ejercicioValidationSchema = Yup.object().shape({
  anio: Yup.number()
    .required('El año es obligatorio')
    .min(1900, 'El año debe ser mayor o igual a 1900')
    .max(2100, 'El año debe ser menor o igual a 2100')
    .integer('El año debe ser un número entero'),
});

export const validateEjercicioForm = async (formData) => {
  try {
    await ejercicioValidationSchema.validate(formData, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) {
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};